import { defineComponent as _defineComponent } from 'vue'
import {ref, onMounted} from "vue";
  import echarts from "echarts";
  import statisticApi from "@/api/statistic";
  import {utils, write} from "xlsx";
  import FileSaver from "file-saver";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorkIndex',
  setup(__props) {

  const showForm = ref(false);
  const chartRef = ref(null);
  const myChart = ref(null as any);
  const screenHeight = document.documentElement.clientHeight;
  const propParams = ref({
    month: '',
  } as any);
  const dataList = ref([]);

  onMounted(() => {
    query();
  });

  const refresh = () => {
    query();
  }

  const reset = () => {
    for(const f in propParams.value){
      propParams.value[f] = "";
    }
    refresh();
  }

  const query = () => {
    statisticApi.getMechanismWorkStatis(propParams.value).then((r: any) => {
      if(r.data.result === 0){
        dataList.value = r.data.data;
        initEchart();
      }
    });
  }

  const onExportExcel = () => {
    let title = "强检器具检定工作统计.xlsx";
    exportExcel(() => {
      console.log("导出成功！");
    }, title);
  }


  const exportExcel = function(callback: any, name: string){
    //如果找不到元素 说明还没加载出来 2秒后再次执行
    if(document.querySelector('#data-table') == undefined){
      setTimeout(() => {
        exportExcel(callback,name);
      }, 2000)
      return;
    }
    let tableDom = document.querySelector('#data-table') as any;
    tableDom = tableDom.cloneNode(true);
    const nodeList = tableDom.querySelectorAll('.export-del-el');
    const nodeListV2 = tableDom.querySelectorAll('.el-table__fixed');
    for (let key = 0; key < nodeList.length; key++) {
      nodeList[key].remove();
    }
    for (let key = 0; key < nodeListV2.length; key++) {
      nodeListV2[key].remove();
    }
    const wb = utils.table_to_book(tableDom, {
      raw: true,
      display: true,
    });
    const wbout = write(wb, {bookType: 'xlsx', bookSST: true, type: 'array'});
    try {
      FileSaver.saveAs(new Blob([wbout], {type: 'application/octet-stream'}), name)
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout);
    }
    callback();
    return wbout;
  }


  const initEchart = () => {
    const data = dataList.value;
    const dataContainer = {} as any; //存分组的
    data.map((item: any) => {
      if(!dataContainer[item.deptName]){
        dataContainer[item.deptName] = 0;
      }
      dataContainer[item.deptName] += item.count;
    });
    myChart.value = echarts.init(chartRef.value);
    var xDataArr = Object.keys(dataContainer)
		var yDataArr = Object.values(dataContainer)
    var option = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          crossStyle: {
            color: '#999'
          }
        },
      },
      xAxis:{
        type:'category',
        data:xDataArr,
      },
      yAxis:{
        type:'value'
      },
      series:[
        {
          type:'bar',
          data:yDataArr,
          barWidth: 30,//固定柱子宽度
          itemStyle: {
            normal: {
              //这里是重点
              color: (params: any) => {
                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                const colorList = ['#9DC8C8', '#58C9B9','#519D9E','#D1B6E1','#FFEEE4','#F17F42','#CE6D39','#D4DFE6','#8EC0E4','#56A902','#f15c5c','#EFDC05','#E53A40','#566270','#8CD790','#F6B352','#F68657','#9055A2','#011638','#EC7357','#8FBC94','#44633F',];
                return colorList[params.dataIndex]
              }
            }
          }
        }
      ]
    }
    myChart.value.setOption(option);
  }



return { __sfc: true,showForm, chartRef, myChart, screenHeight, propParams, dataList, refresh, reset, query, onExportExcel, exportExcel, initEchart }
}

})